import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

export const keyPrefix = 'chart_form';
export const useChartFormTranslation = () => useTranslation('entities', { keyPrefix });
export const i18nChartFormTranslation = (key: string) => i18next.t(`entities:${keyPrefix}.${key}`);

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    tabs: {
      basic_parameters: 'Базовые параметры',
      grouping: 'Группировка',
      filters: 'Фильтры',
    },
    diagram_type: {
      change_title: 'Смена типа диаграммы',
      change_message: 'Группировка будет очищена. Вы уверены, что хотите сменить тип диаграммы?',
    },
    btn: {
      refresh: 'Обновить',
      reset_to_default: 'Вернуть по умолчанию',
      add_field: 'Добавить поле',
      remove: 'Удалить',
    },
    aggregators: {
      group_by: 'Группировка',
      avg: 'Среднее значение',
      max: 'Максимальное значение',
      min: 'Минимальное значение',
      count: 'Количество',
    },
    form: {
      common: {
        name: {
          label: 'Название',
        },
        diagram_type: {
          label: 'Тип диаграммы',
        },
        main_targets: {
          column: {
            label: 'Данные',
            tooltip: 'Поле, которое должно быть заполнено у события',
          },
        },
        aggregator: {
          label: 'Агрегатор',
          tooltip: 'Функция, с помощью которой будут агрегированы выбранные данные',
        },
      },
      clustering: {
        group_by_time: 'По времени',
        group_by_field: 'По значению поля',
        group_by: 'Группировать по',
        count: '$t(entities:chart_form.aggregators.count)',
        dimension: 'Размерность',
        frequency: 'Частота',
        field: '$t(entities:chart_form.form.filters.field.label)',
        tooltip: {
          two_fields: "Недоступно когда выбраны две группировки 'По значению поля'",
          pie_or_doughnut: 'Недоступно для типов диаграмм - Пончик, Пирог',
          interval: 'Для активации необходимо выбрать группировку по временным интервалам',
          frequency: 'Для активации необходимо выбрать группировку по частоте',
        },
      },
      filters: {
        period: {
          label: 'Период',
          from: 'От',
          to: 'До',
        },
        data: {
          label: 'Данные',
        },
        field: {
          label: 'Поле',
        },
        function: {
          label: 'Функция',
          tooltip: 'Для активации выберите “Поле”',
        },
        value: {
          label: 'Значение',
          tooltip: 'Для активации выберите “Функцию”',
        },
      },
      geolocation: {
        title: 'Область',
        longitude: {
          label: 'Долгота',
        },
        latitude: {
          label: 'Широта',
        },

      },
    },
    options: {
      diagram_type: {
        bar: 'Колонны',
        horizontal_bar: 'Полосы',
        area: 'Области',
        step_area: 'Шаговые области',
        stack: 'Стеки',
        line: 'Линии',
        pie: 'Пирог',
        doughnut: 'Пончик',
        radar: 'Роза ветров',
      },
      chart_type: {
        age_distribution: 'Распределение по возрасту',
        gender_ratio: 'Соотношение полов',
        attendance_by_gender: 'Посещаемость по полу',
        gender_distribution: 'Распределение по полу',
        emotion_distribution: 'Распределение по эмоциям',
        average_age_by_gender: 'Динамика среднего возраста по полу',
      },
      aggregator: {
        count: '$t(entities:chart_form.aggregators.count)',
        max: '$t(entities:chart_form.aggregators.max)',
        min: '$t(entities:chart_form.aggregators.min)',
        avg: '$t(entities:chart_form.aggregators.avg)',
      },
      time_grouping: {
        interval: 'По временным интервалам',
        frequency: 'По частоте',
      },
      time_dimension: {
        minute: 'Минута',
        hour: 'Час',
        day: 'День',
        week: 'Неделя',
        month: 'Месяц',
        year: 'Год',
      },
      frequency: {
        month_of_year: 'По месяцам года',
        week_of_year: 'По неделям года',
        day_of_year: 'По дням года',
        day_of_month: 'По дням месяца',
        day_of_week: 'По дням недели',
        hour_of_day: 'По часам дня',
        minute_of_hour: 'По минутам часа',
      },
      filter_function: {
        like: 'Содержит символ',
        nlike: 'Не содержит символ',
        in: 'Включает значение',
        nin: 'Не включает значение',
        eq: 'Равно',
        neq: 'Не равно',
        gt: 'Больше',
        gte: 'Больше или равно',
        lt: 'Меньше',
        lte: 'Меньше или равно',
        covered: 'Попадает в область',
      },
      filter_field: {
        tags: 'Тег',
        source: 'Источник',
        stream_id: 'ID потока',
        user_data: 'Данные пользователя',
        event_id: 'ID события',
        external_id: 'Внешний ID',
        handler_id: 'ID сценария',
        top_similar_object_id: 'ID наиболее похожего объекта',
        top_similar_external_id: 'Наиболее похожий внешний ID',
        lists: 'Списки',
        top_matching_candidates_label: 'Сравнение с кандидатами с самой высокой степенью схожести',
        top_similar_object_similarity: 'Степень схожести наиболее похожего объекта',
        face_id: 'ID лица',
        gender: 'Пол',
        age: 'Возраст',
        emotion: 'Эмоция',
        mask: 'Маска',
        liveness: 'Liveness',
        deepfake: 'Deepfake',
        city: 'Город',
        area: 'Область',
        district: 'Район',
        street: 'Улица',
        house_number: 'Номер дома',
        geo_position: 'Геопозиция',
        track_id: 'ID трека',
        apparent_age: 'Предполагаемый возраст',
        apparent_gender: 'Предполагаемый пол',
        sleeve_length: 'Длина рукава',
        headwear_state: 'Состояние головного убора',
        headwear_apparent_color: 'Цвет головного убора',
        upper_clothing_colors: 'Цвет верхней одежды',
        lower_garment_colors: 'Цвет нижней одежды',
        lower_garment_type: 'Тип нижней одежды',
        shoes_apparent_color: 'Цвет обуви',
        backpack_state: 'Состояние рюкзака',
        meta: 'Метаданные',
        create_time: 'Дата создания',
        end_time: 'Дата завершения',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    tabs: {
      basic_parameters: 'Basic parameters',
      grouping: 'Grouping',
      filters: 'Filters',
    },
    diagram_type: {
      change_title: 'Change chart type',
      change_message: 'Grouping will be cleared. Are you sure you want to change the chart type?',
    },
    btn: {
      refresh: 'Refresh',
      reset_to_default: 'Reset to default',
      add_field: 'Add field',
      remove: 'Remove',
    },
    aggregators: {
      group_by: 'Grouping',
      avg: 'Average value',
      max: 'Maximum value',
      min: 'Minimum value',
      count: 'Count',
    },
    form: {
      common: {
        name: {
          label: 'Name',
        },
        diagram_type: {
          label: 'Chart type',
        },
        main_targets: {
          column: {
            label: 'Data',
            tooltip: 'The field that must be filled in for the event',
          },
        },
        aggregator: {
          label: 'Aggregator',
          tooltip: 'The function that will aggregate the selected data',
        },
      },
      clustering: {
        group_by_time: 'Group by time',
        group_by_field: 'Group by field',
        group_by: 'Group by',
        count: '$t(entities:chart_form.aggregators.count)',
        dimension: 'Dimension',
        frequency: 'Frequency',
        field: '$t(entities:chart_form.form.filters.field.label)',
        tooltip: {
          two_fields: "Unavailable when two 'Field' groupings are selected",
          pie_or_doughnut: 'Unavailable for chart types - Doughnut, Pie',
          interval: 'To activate, select grouping by time intervals',
          frequency: 'To activate, select grouping by frequency',
        },
      },
      filters: {
        period: {
          label: 'Period',
          from: 'From',
          to: 'To',
        },
        data: {
          label: 'Data',
        },
        field: {
          label: 'Field',
        },
        function: {
          label: 'Function',
          tooltip: "To activate, select 'Field'",
        },
        value: {
          label: 'Value',
          tooltip: "To activate, select 'Function'",
        },
      },
      geolocation: {
        title: 'Area',
        longitude: {
          label: 'Longitude',
        },
        latitude: {
          label: 'Latitude',
        },
      },
    },
    options: {
      diagram_type: {
        bar: 'Bars',
        horizontal_bar: 'Horizontal bars',
        area: 'Areas',
        step_area: 'Step areas',
        stack: 'Stacks',
        line: 'Lines',
        pie: 'Pie',
        doughnut: 'Doughnut',
        radar: 'Radar',
      },
      chart_type: {
        age_distribution: 'Age distribution',
        gender_ratio: 'Gender ratio',
        attendance_by_gender: 'Attendance by gender',
        gender_distribution: 'Gender distribution',
        emotion_distribution: 'Emotion distribution',
        average_age_by_gender: 'Average age by gender',
      },
      aggregator: {
        count: '$t(entities:chart_form.aggregators.count)',
        max: '$t(entities:chart_form.aggregators.max)',
        min: '$t(entities:chart_form.aggregators.min)',
        avg: '$t(entities:chart_form.aggregators.avg)',
      },
      time_grouping: {
        interval: 'By time intervals',
        frequency: 'By frequency',
      },
      time_dimension: {
        minute: 'Minute',
        hour: 'Hour',
        day: 'Day',
        week: 'Week',
        month: 'Month',
        year: 'Year',
      },
      frequency: {
        month_of_year: 'By months of the year',
        week_of_year: 'By weeks of the year',
        day_of_year: 'By days of the year',
        day_of_month: 'By days of the month',
        day_of_week: 'By days of the week',
        hour_of_day: 'By hours of the day',
        minute_of_hour: 'By minutes of the hour',
      },
      filter_function: {
        like: 'Contains symbol',
        nlike: 'Does not contain symbol',
        in: 'Includes value',
        nin: 'Excludes value',
        eq: 'Equals',
        neq: 'Not equals',
        gt: 'Greater than',
        gte: 'Greater than or equal to',
        lt: 'Less than',
        lte: 'Less than or equal to',
        covered: 'Covered',
      },
      filter_field: {
        tags: 'Tag',
        source: 'Source',
        stream_id: 'Stream ID',
        user_data: 'User data',
        event_id: 'Event ID',
        external_id: 'External ID',
        handler_id: 'Handler ID',
        top_similar_object_id: 'Top similar object ID',
        top_similar_external_id: 'Top similar external ID',
        lists: 'Lists',
        top_matching_candidates_label: 'Top matching candidates label',
        top_similar_object_similarity: 'Top similar object similarity',
        face_id: 'Face ID',
        gender: 'Gender',
        age: 'Age',
        emotion: 'Emotion',
        mask: 'Mask',
        liveness: 'Liveness',
        deepfake: 'Deepfake',
        city: 'City',
        area: 'Area',
        district: 'District',
        street: 'Street',
        house_number: 'House number',
        geo_position: 'Geo position',
        track_id: 'Track ID',
        apparent_age: 'Apparent age',
        apparent_gender: 'Apparent gender',
        sleeve_length: 'Sleeve length',
        headwear_state: 'Headwear state',
        headwear_apparent_color: 'Headwear apparent color',
        upper_clothing_colors: 'Upper clothing colors',
        lower_garment_colors: 'Lower garment colors',
        lower_garment_type: 'Lower garment type',
        shoes_apparent_color: 'Shoes apparent color',
        backpack_state: 'Backpack state',
        meta: 'Metadata',
        create_time: 'Creation date',
        end_time: 'Completion date',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    tabs: {
      basic_parameters: 'Parâmetros básicos',
      grouping: 'Agrupamento',
      filters: 'Filtros',
    },
    diagram_type: {
      change_title: 'Alterar tipo de gráfico',
      change_message: 'O agrupamento será limpo. Tem certeza de que deseja alterar o tipo de gráfico?',
    },
    btn: {
      refresh: 'Atualizar',
      reset_to_default: 'Repor preconfigurações',
      add_field: 'Adicionar campo',
      remove: 'Remover',
    },
    aggregators: {
      group_by: 'Agrupamento',
      avg: 'Valor médio',
      max: 'Valor máximo',
      min: 'Valor mínimo',
      count: 'Contagem',
    },
    form: {
      common: {
        name: {
          label: 'Nome',
        },
        diagram_type: {
          label: 'Tipo de gráfico',
        },
        main_targets: {
          column: {
            label: 'Dados',
            tooltip: 'O campo que deve ser preenchido para o evento',
          },
        },
        aggregator: {
          label: 'Agregador',
          tooltip: 'A função que irá agregar os dados selecionados',
        },
      },
      clustering: {
        group_by_time: 'Agrupar por tempo',
        group_by_field: 'Agrupar por campo',
        group_by: 'Agrupar por',
        count: '$t(entities:chart_form.aggregators.count)',
        dimension: 'Dimensão',
        frequency: 'Frequência',
        field: '$t(entities:chart_form.form.filters.field.label)',
        tooltip: {
          two_fields: "Indisponível quando dois agrupamentos 'Campo' estão selecionados",
          pie_or_doughnut: 'Indisponível para tipos de gráfico - Rosca, Circular',
          interval: 'Para ativar, selecione agrupamento por intervalos de tempo',
          frequency: 'Para ativar, selecione agrupamento por frequência',
        },
      },
      filters: {
        period: {
          label: 'Período',
          from: 'De',
          to: 'Até',
        },
        data: {
          label: 'Dados',
        },
        field: {
          label: 'Campo',
        },
        function: {
          label: 'Função',
          tooltip: "Para ativar, selecione 'Campo'",
        },
        value: {
          label: 'Valor',
          tooltip: "Para ativar, selecione 'Função'",
        },
      },
      geolocation: {
        title: 'Área',
        longitude: {
          label: 'Longitude',
        },
        latitude: {
          label: 'Latitude',
        },
      },
    },
    options: {
      diagram_type: {
        bar: 'Barras',
        horizontal_bar: 'Barras horizontais',
        area: 'Áreas',
        step_area: 'Áreas em degrau',
        stack: 'Empilhado',
        line: 'Linhas',
        pie: 'Circular',
        doughnut: 'Rosca',
        radar: 'Radar',
      },
      chart_type: {
        age_distribution: 'Distribuição por idade',
        gender_ratio: 'Proporção de género',
        attendance_by_gender: 'Frequência por género',
        gender_distribution: 'Distribuição por género',
        emotion_distribution: 'Distribuição de emoções',
        average_age_by_gender: 'Idade média por género',
      },
      aggregator: {
        count: '$t(entities:chart_form.aggregators.count)',
        max: '$t(entities:chart_form.aggregators.max)',
        min: '$t(entities:chart_form.aggregators.min)',
        avg: '$t(entities:chart_form.aggregators.avg)',
      },
      time_grouping: {
        interval: 'Por intervalos de tempo',
        frequency: 'Por frequência',
      },
      time_dimension: {
        minute: 'Minuto',
        hour: 'Hora',
        day: 'Dia',
        week: 'Semana',
        month: 'Mês',
        year: 'Ano',
      },
      frequency: {
        month_of_year: 'Por meses do ano',
        week_of_year: 'Por semanas do ano',
        day_of_year: 'Por dias do ano',
        day_of_month: 'Por dias do mês',
        day_of_week: 'Por dias da semana',
        hour_of_day: 'Por horas do dia',
        minute_of_hour: 'Por minutos da hora',
      },
      filter_function: {
        like: 'Contém símbolo',
        nlike: 'Não contém símbolo',
        in: 'Inclui valor',
        nin: 'Exclui valor',
        eq: 'Igual a',
        neq: 'Diferente de',
        gt: 'Maior que',
        gte: 'Maior ou igual a',
        lt: 'Menor que',
        lte: 'Menor ou igual a',
        covered: 'Coberto',
      },
      filter_field: {
        tags: 'Tag',
        source: 'Fonte',
        stream_id: 'ID do fluxo',
        user_data: 'Dados do usuário',
        event_id: 'ID do evento',
        external_id: 'ID externo',
        handler_id: 'ID do handler',
        top_similar_object_id: 'ID do objeto mais semelhante',
        top_similar_external_id: 'ID externo mais semelhante',
        lists: 'Listas',
        top_matching_candidates_label: 'Tag dos candidatos mais correspondentes',
        top_similar_object_similarity: 'Semelhança do objeto mais semelhante',
        face_id: 'ID da face',
        gender: 'Género',
        age: 'Idade',
        emotion: 'Emoção',
        mask: 'Máscara',
        liveness: 'Liveness',
        deepfake: 'Deepfake',
        city: 'Cidade',
        area: 'Área',
        district: 'Distrito',
        street: 'Rua',
        house_number: 'Número da casa',
        geo_position: 'Geoposição',
        track_id: 'ID da trilha',
        apparent_age: 'Idade aparente',
        apparent_gender: 'Género aparente',
        sleeve_length: 'Comprimento da manga',
        headwear_state: 'Estado do chapéu/boné',
        headwear_apparent_color: 'Cor aparente do chapéu/boné',
        upper_clothing_colors: 'Cores da roupa superior',
        lower_garment_colors: 'Cores da roupa inferior',
        lower_garment_type: 'Tipo de roupa inferior',
        shoes_apparent_color: 'Cor aparente dos sapatos',
        backpack_state: 'Estado da mochila',
        meta: 'Metadados',
        create_time: 'Data de criação',
        end_time: 'Data de conclusão',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    tabs: {
      basic_parameters: 'Parámetros básicos',
      grouping: 'Agrupamiento',
      filters: 'Filtros',
    },
    diagram_type: {
      change_title: 'Cambiar el tipo de gráfico',
      change_message: 'Se borrará la agrupación. ¿Está seguro de que desea cambiar el tipo de gráfico?',
    },
    btn: {
      refresh: 'Refrescar',
      reset_to_default: 'Restablecer a valores predeterminados',
      add_field: 'Agregar un campo',
      remove: 'Borrar',
    },
    form: {
      common: {
        name: {
          label: 'Nombre',
        },
        diagram_type: {
          label: 'Tipo de gráfico',
        },
        main_targets: {
          column: {
            label: 'Datos',
            tooltip: 'Un campo que debe rellenarse para un evento',
          },
        },
        aggregator: {
          label: 'Agregador',
          tooltip: 'La función mediante la cual se agregarán los datos seleccionados',
        },
      },
      clustering: {
        group_by_time: 'Para el momento',
        group_by_field: 'Por valor de campo',
        group_by: 'Agrupar por',
        count: 'Cantidad',
        dimension: 'Dimensión',
        frequency: 'Frecuencia',
        field: 'Campo',
        tooltip: {
          two_fields: "No disponible cuando se seleccionan dos agrupaciones 'Por valor de campo'",
          pie_or_doughnut: 'No disponible para los tipos de gráficos: Donut, Pastel',
          interval: 'Para activarlo, debe seleccionar la agrupación por intervalos de tiempo',
          frequency: 'Para activarlo, debe seleccionar una agrupación de frecuencias',
        },
      },
      filters: {
        period: {
          label: 'Período',
          from: 'De',
          to: 'A',
        },
        data: {
          label: 'Datos',
        },
        field: {
          label: 'Campo',
        },
        function: {
          label: 'Función',
          tooltip: 'Para activar, seleccione “Campo”',
        },
        value: {
          label: 'Valor',
          tooltip: 'Para activar, seleccione “Función”',
        },
      },
      geolocation: {
        title: 'Región',
        longitude: {
          label: 'Longitud',
        },
        latitude: {
          label: 'Latitud',
        },
      },
    },
  },
}) : {}) as Record<string, unknown>;
